export const Tool = {

  getObjectReference (obj, dottedString) {
    // Criado pelo SearchLabs do Google :)
    return dottedString.split('.').reduce((currentObject, propertyName) => {
      if (currentObject && typeof currentObject === 'object' && propertyName in currentObject) {
        return currentObject[propertyName];
      } else {
        // Handle cases where a part of the path doesn't exist
        return undefined;
      }
    }, obj);
  },

  copyList (list, invert = false) {
    let copy = list.slice();
    if (invert) {
      copy.reverse();
    }
    return copy;
  },

  sortList (list, property, type, reverse = false) {
    reverse = reverse ? -1 : 1;
    let mapped;
    if (list.length > 0) {
      switch (type) {
        case 'number':
          mapped = list.map((element, index) => {
            return {index, value: Number(element[property])};
          });
          mapped.sort((a, b) => {
            if (a.value > b.value) {
              return 1 * reverse;
            }
            if (a.value < b.value) {
              return -1 * reverse;
            }
            return 0;
          });
          list = mapped.map(element => list[element.index]);
          break;
        case 'string':
          mapped = list.map((element, index) => {
            return {index, value: element[property]};
          });
          mapped.sort((a, b) => {
            return a.value.localeCompare(b.value) * reverse;
          });
          list = mapped.map(element => list[element.index]);
          break;
        case 'date':
          mapped = list.map((element, index) => {
            return {index, value: this.dateDMYtoYMD(element[property])};
          });
          mapped.sort((a, b) => {
            if (a.value > b.value) {
              return 1 * reverse;
            }
            if (a.value < b.value) {
              return -1 * reverse;
            }
            return 0;
          });
          list = mapped.map(element => list[element.index]);
          break;
      }
    }
    return list;
  },

  dataJSON (data) {
    if (data === null || data === undefined) {
      return data;
    }
    switch (typeof data) {
      case 'string': return JSON.parse(data.replaceAll('&quot;', '"'));
      case 'object': return JSON.stringify(data).replaceAll('"', '&quot;');
    }
  },

  lpad (string, charpad, chars) {
    let mask = '';
    for (let i = 0; i < chars; i += 1) {
      mask += charpad;
    }
    return mask.substr(string.length) + string;
  },

  round (number, digits) {
    // digits = Math.pow(10, digits);
    // return Math.round(number * digits) / digits;
    return Number(Math.round(number + 'e' + digits) + 'e-' + digits);
  },

  cpfToDigits (cpf) {
    if (/[0-9]{3}\.[0-9]{3}\.[0-9]{3}\-[0-9]{2}/.test(cpf)) {
      return cpf.replaceAll(/[-.]/g, '');
    } else {
      return cpf;
    }
  },

  digitsToCpf (digits) {
    if (/[0-9]{11}/.test(digits)) {
      return [[digits.substr(0, 3), digits.substr(3, 3), digits.substr(6, 3)].join('.'), digits.substr(9, 2)].join('-');
    } else {
      return digits;
    }
  },

  digitsToCnpj (digits) {
    if (/[0-9]{14}/.test(digits)) {
      return [[[digits.substr(0, 2), digits.substr(2, 3), digits.substr(5, 3)].join('.'), digits.substr(8, 4)].join('/'), digits.substr(12, 2)].join('-');
    } else {
      return digits;
    }
  },

  digitsToNumeroCnj (digits) {
    if (/[0-9]{20}/.test(digits)) {
      return [digits.substr(0, 7), [digits.substr(7, 2), digits.substr(9, 4), digits.substr(13, 1), digits.substr(14, 2), digits.substr(16, 4)].join('.')].join('-');
    } else {
      return digits;
    }
  },

  cepToDigits (cep) {
    if (/[0-9]{5}\-[0-9]{3}/.test(cep)) {
      return cep.split('-').join('');
    } else {
      return cep;
    }
  },

  digitsToCep (digits) {
    if (/[0-9]{8}/.test(digits)) {
      return [digits.substr(0, 5), digits.substr(5, 3)].join('-');
    } else {
      return digits;
    }
  },

  phoneToDigits (phone) {
    if (/\([0-9]{2}\)\s?[0-9]{4,5}\-?[0-9]{4}/.test(phone)) {
      return phone.split(/[() -]/).join('');
    } else {
      return phone;
    }
  },

  digitsToPhone (digits) {
    if (/[0-9]{10,11}/.test(digits)) {
      return '(' + digits.substr(0, 2) + ') ' + (digits.length === 11 ? digits.substr(2, 5) : digits.substr(2, 4)) + '-' + digits.substr(-4, 4);
    } else {
      return digits;
    }
  },

  isLeapYear (year) {
    let isLeap = year => new Date(year, 1, 29).getDate() === 29;
  },

  dateDMYtoYMD (dateDMY) {
    if (/[0-9]{2}\/[0-9]{2}\/[0-9]{4}/.test(dateDMY)) {
      return dateDMY.split('/').reverse().join('-');
    } else {
      return dateDMY;
    }
  },

  dateYMDtoDMY (dateYMD) {
    if (/[0-9]{4}\-[0-9]{2}\-[0-9]{2}/.test(dateYMD)) {
      return dateYMD.split('-').reverse().join('/');
    } else {
      return dateYMD;
    }
  },

  datetimeConvert (datetime, preserveGlue = false) {
    if (/[0-9]{4}\-[0-9]{2}\-[0-9]{2}T[0-9]{2}\:[0-9]{2}(\:[0-9]{2})?/.test(datetime)) {
      let pieces = datetime.split('T');
      pieces[0] = this.dateYMDtoDMY(pieces[0]);
      return pieces.join(preserveGlue ? 'T' : ' ');
    } else if (/[0-9]{2}\/[0-9]{2}\/[0-9]{4}\s[0-9]{2}\:[0-9]{2}(\:[0-9]{2})?/.test(datetime)) {
      let pieces = datetime.split(' ');
      pieces[0] = this.dateDMYtoYMD(pieces[0]);
      return pieces.join(preserveGlue ? ' ' : 'T');
    } else {
      return datetime;
    }
  },

  dateInInterval (date, start, end) {
    let erDMY = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;
    let erYMD = /[0-9]{4}\-[0-9]{2}\-[0-9]{2}/;
    // Check and convert dates format to YMD
    if (erDMY.test(date)) {
      date = date.split('/').reverse().join('-');
    }
    if (erDMY.test(start)) {
      start = start.split('/').reverse().join('-');
    }
    if (erDMY.test(end)) {
      end = end.split('/').reverse().join('-');
    }
    // Check if dates are valid
    if (erYMD.test(date) && erYMD.test(start) && erYMD.test(end)) {
      date = date.split('-');
      start = start.split('-');
      end = end.split('-');
      let cmpDate = new Date(Number(date[0]), Number(date[1]) - 1, Number(date[2]));
      let cmpStart = new Date(Number(start[0]), Number(start[1]) - 1, Number(start[2]));
      let cmpEnd = new Date(Number(end[0]), Number(end[1]) - 1, Number(end[2]) + 1); // day after
      if (cmpEnd.getTime() > cmpStart.getTime()) {
        return (
          cmpDate.getTime() < cmpEnd.getTime() && // day after
          cmpDate.getTime() >= cmpStart.getTime()
        );
      } else {
        return -2;
      }
    } else {
      return -1;
    }
  },

  datetimeInterval (start, end) {
    let erDMYHIS = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}\s[0-9]{2}\:[0-9]{2}(\:[0-9]{2})?/;
    let erYMDHIS = /[0-9]{4}\-[0-9]{2}\-[0-9]{2}\s[0-9]{2}\:[0-9]{2}(\:[0-9]{2})?/;
    // Check and convert dates format to YMD
    if (erDMYHIS.test(start)) {
      start = this.datetimeConvert(start, true);
    }
    if (erDMYHIS.test(end)) {
      end = this.datetimeConvert(end, true);
    }
    // Check if dates are valid
    if (erYMDHIS.test(start) && erYMDHIS.test(end)) {
      start = start.split(' ');
      end = end.split(' ');
      let dateStart = start[0].split('-');
      let timeStart = start[1].split(':');
      let dateEnd = end[0].split('-');
      let timeEnd = end[1].split(':');
      if (timeStart.length === 2) {
        timeStart.push('00');
      }
      if (timeEnd.length === 2) {
        timeEnd.push('00');
      }
      let cmpStart = new Date(Number(dateStart[0]), Number(dateStart[1]) - 1, Number(dateStart[2]), Number(timeStart[0]), Number(timeStart[1]), Number(timeStart[2]));
      let cmpEnd = new Date(Number(dateEnd[0]), Number(dateEnd[1]) - 1, Number(dateEnd[2]), Number(timeEnd[0]), Number(timeEnd[1]), Number(timeEnd[2]));
      if (cmpEnd.getTime() >= cmpStart.getTime()) {
        return (cmpEnd.getTime() - cmpStart.getTime()) / 1000;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },

  dateCompInterval (date, start, end) {
    let erDMY = /[0-9]{2}\/[0-9]{2}\/[0-9]{4}/;
    let erYMD = /[0-9]{4}\-[0-9]{2}\-[0-9]{2}/;
    // Check and convert dates format to YMD
    if (erDMY.test(date)) {
      date = date.split('/').reverse().join('-');
    }
    if (erDMY.test(start)) {
      start = start.split('/').reverse().join('-');
    }
    if (erDMY.test(end)) {
      end = end.split('/').reverse().join('-');
    }
    // Check if dates are valid
    if (erYMD.test(date) && erYMD.test(start) && erYMD.test(end)) {
      date = date.split('-');
      start = start.split('-');
      end = end.split('-');
      let cmpDate = new Date(Number(date[0]), Number(date[1]) - 1, Number(date[2]));
      let cmpStart = new Date(Number(start[0]), Number(start[1]) - 1, Number(start[2]));
      let cmpEnd = new Date(Number(end[0]), Number(end[1]) - 1, Number(end[2]) + 1); // day after
      if (cmpEnd.getTime() > cmpStart.getTime()) {
        if (cmpDate.getTime() >= cmpEnd.getTime()) {
          return 1;
        } else if (cmpDate.getTime() < cmpStart.getTime()) {
          return -1;
        } else {
          return 0;
        }
      }
    }
  },

  ucfirst (string) {
    if (typeof string === 'string') {
      string = string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  },

  removeAccents (string, toLowerCase = false) {
    // https://ricardometring.com/javascript-replace-special-characters
    string = String(string).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (toLowerCase) {
      string = string.toLowerCase();
    }
    return string;
  },

  createSlug (string) {
    return this.removeAccents(string, true).replaceAll(/\s/g, '-');
  },

  htmlentities (string) {
    // return String(string).replace('&', '&amp;').replace('<', '&lt;').replace('>', '&gt;');
    return string === null ? null : String(string).replaceAll('<', '&lt;').replaceAll('>', '&gt;');
  }

};